import type { MenuProps } from 'antd';
import { EEventHistoryMenuKey } from 'entities/History/History.enum';

export const eventHistoryMenuItems: MenuProps['items'] = [
  {
    label: 'Notes',
    key: EEventHistoryMenuKey.Notes,
  },
  {
    label: 'Event History',
    key: EEventHistoryMenuKey.EventHistory,
  },
  {
    label: 'All',
    key: EEventHistoryMenuKey.All,
  },
];
